<!--
 * 对齐编辑器
 * @author: Mengyu Jin
 * @since: 2022-06-15 15:17:38
-->

<template>
  <div :class="['page--cat-alignment__editor', 'flex-col', componentRootId]">
    <el-card class="alignment__editor-wrapper flex-col">
      <RibbonTable v-model="pageLocation">
        <RibbonPanel name="aligment" label="双语对齐">
          <RibbonBlock label="common" title="常用">
            <template v-slot="scope">
              <RibbonButton
                size="large"
                icon="fa:save"
                icon-class="color-primary"
                label="保存"
                @click="handleClickSave"
              ></RibbonButton>
              <RibbonDropMenu
                text="导出"
                size="large"
                icon-class="color-regular"
                @command="
                  (command) => handleExportCommand(command, exportOptions.tm)
                "
                :disabled="
                  state === null ||
                  !exportOptions.tm.validateOption.checkExportable({ state })
                "
                :title="
                  !exportOptions.tm.validateOption.checkExportable({ state })
                    ? exportOptions.tm.validateOption.disabledTip
                    : null
                "
              >
                <svg-icon
                  icon="export-asset"
                  slot="icon"
                  style="font-size: 28px"
                ></svg-icon>
                <RibbonDropMenuItem
                  :command="command"
                  v-for="(format, command) in exportOptions.tm.formats"
                  :key="command"
                >
                  {{ command }}
                </RibbonDropMenuItem>
              </RibbonDropMenu>
              <RibbonBlockGroup>
                <div class="ml-6 mr-6">
                  <RibbonButton
                    icon="fa:undo"
                    icon-class="color-regular"
                    label="撤销"
                    @click="handleClickUndo"
                  ></RibbonButton>
                  <RibbonButton
                    icon="fa:redo"
                    icon-class="color-regular"
                    label="重做"
                    @click="handleClickRedo"
                  ></RibbonButton>
                </div>
              </RibbonBlockGroup>
            </template>
          </RibbonBlock>
          <RibbonBlock label="segment" title="句段">
            <template v-slot="scope">
              <RibbonButton
                size="large"
                icon-class="color-regular"
                label="插入"
                @click="handleClickOperation(OPERATION.insert)"
              >
                <svg-icon
                  icon="insert-line"
                  style="font-size: 28px; transform: rotateY(180deg)"
                  slot="icon"
                ></svg-icon>
              </RibbonButton>
              <RibbonButton
                size="large"
                icon-class="color-regular"
                label="删除"
                @click="handleClickOperation(OPERATION.delete)"
              >
                <svg-icon
                  icon="delete-line"
                  style="font-size: 28px"
                  slot="icon"
                ></svg-icon>
              </RibbonButton>
              <RibbonBlockGroup>
                <div class="ml-6 mr-6">
                  <RibbonButton
                    icon="fa:arrow-up"
                    icon-class="color-regular"
                    label="上移"
                    @click="handleClickOperation(OPERATION.moveup)"
                  ></RibbonButton>
                  <RibbonButton
                    icon="fa:arrow-down"
                    icon-class="color-regular"
                    label="下移"
                    @click="handleClickOperation(OPERATION.movedown)"
                  ></RibbonButton>
                </div>
              </RibbonBlockGroup>
              <RibbonButton
                size="large"
                icon="fa:exchange-alt"
                icon-class="color-regular"
                label="调换"
                @click="handleClickOperation(OPERATION.swap)"
              ></RibbonButton>
              <RibbonBlockGroup>
                <div class="ml-6 mr-6">
                  <RibbonButton
                    icon="far:object-group"
                    icon-class="color-regular"
                    label="合并句段"
                    @click="handleClickOperation(OPERATION.merge)"
                  ></RibbonButton>
                  <RibbonButton
                    icon="far:object-ungroup"
                    icon-class="color-regular"
                    label="拆分句段"
                    @click="handleClickOperation(OPERATION.split)"
                  ></RibbonButton>
                </div> </RibbonBlockGroup
            ></template>
          </RibbonBlock>
          <RibbonBlock label="data" title="样式">
            <template v-slot="scope">
              <RibbonDropMenu
                icon="fa:font"
                size="large"
                icon-class="color-regular"
                text="字号设置"
                @command="setFontSize"
              >
                <RibbonDropMenuItem command="little">
                  <span class="inline-block" style="width: 72px">小</span>
                </RibbonDropMenuItem>
                <RibbonDropMenuItem command="medium"> 中 </RibbonDropMenuItem>
                <RibbonDropMenuItem command="big"> 大 </RibbonDropMenuItem>
                <RibbonDropMenuItem command="large"> 特大 </RibbonDropMenuItem>
              </RibbonDropMenu>
            </template>
          </RibbonBlock>
          <RibbonBlock label="glossary" title="术语" v-if="isAligned">
            <template v-slot="scope">
              <RibbonButton
                size="large"
                icon="el-icon-collection"
                icon-class="color-regular"
                label="提取术语"
                @click="handleExtract"
              ></RibbonButton>
              <RibbonBlockGroup>
                <div class="ml-6 mr-6">
                  <RibbonButton
                    icon="fa:eye"
                    icon-class="color-regular"
                    label="查看术语"
                    :disabled="!ateProject.id"
                    :title="!ateProject.id ? '请先提取术语' : null"
                    @click="viewExtract"
                  ></RibbonButton>
                  <el-popover :width="435" style="line-height: 32px">
                    <RibbonButton
                      class="alignment__supported-glossary-langs"
                      icon="far:file-alt"
                      icon-class="color-regular"
                      label="支持语种"
                      slot="reference"
                    ></RibbonButton>
                    <div
                      v-for="ateSupportedLanguage in ateSupportedLanguages"
                      :key="ateSupportedLanguage.title"
                      class="mt-12"
                    >
                      <div class="el-popover__title" style="margin-bottom: 6px">
                        {{ ateSupportedLanguage.title }}
                      </div>
                      {{ ateSupportedLanguage.list.join("、") + " 任意语对" }}
                    </div>
                  </el-popover>
                </div>
              </RibbonBlockGroup>
            </template>
          </RibbonBlock>
        </RibbonPanel>
        <RibbonPanel
          name="extract"
          label="术语提取"
          v-if="state == ALIGNMENT_TASK_STATE.extractDone"
        >
          <RibbonBlock label="common" title="常用">
            <template v-slot="scope">
              <RibbonButton
                size="large"
                icon="fa:save"
                icon-class="color-primary"
                label="保存"
                @click="saveATE"
              ></RibbonButton>
            </template>
          </RibbonBlock>
          <RibbonBlock label="batch" title="批量操作">
            <template v-slot="scope">
              <RibbonButton
                size="large"
                icon="fa:trash-alt"
                icon-class="color-danger"
                label="删除"
                @click="deleteATE"
              ></RibbonButton>
              <RibbonDropMenu
                text="导出"
                size="large"
                icon-class="color-regular"
                @command="
                  (command) => handleExportCommand(command, exportOptions.tb)
                "
                :disabled="
                  state === null ||
                  !exportOptions.tb.validateOption.checkExportable({ state })
                "
                :title="
                  !exportOptions.tb.validateOption.checkExportable({ state })
                    ? exportOptions.tb.validateOption.disabledTip
                    : null
                "
              >
                <svg-icon
                  icon="export-asset"
                  slot="icon"
                  style="font-size: 28px"
                ></svg-icon>
                <RibbonDropMenuItem
                  :command="command"
                  v-for="(format, command) in exportOptions.tb.formats"
                  :key="command"
                >
                  {{ command }}
                </RibbonDropMenuItem>
              </RibbonDropMenu>
            </template>
          </RibbonBlock>
          <RibbonBlock label="segment" title="查询">
            <template v-slot="scope">
              <RibbonBlockGroup>
                <div class="filter-row">
                  <span>原文长度：</span>
                  <ve-input-number
                    class="input-number__word-count"
                    size="mini"
                    :min="1"
                    v-model="filter.srcMinLength"
                  ></ve-input-number>
                  <span>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                  <ve-input-number
                    class="input-number__word-count"
                    size="mini"
                    :min="1"
                    v-model="filter.srcMaxLength"
                  ></ve-input-number>
                </div>
                <div class="filter-row">
                  <span>译文长度：</span>
                  <ve-input-number
                    class="input-number__word-count"
                    size="mini"
                    :min="0"
                    v-model="filter.tgtMinLength"
                  ></ve-input-number>
                  <span>&nbsp;&nbsp;~&nbsp;&nbsp;</span>
                  <ve-input-number
                    class="input-number__word-count"
                    size="mini"
                    :min="1"
                    v-model="filter.srcMaxLength"
                  ></ve-input-number>
                </div>
              </RibbonBlockGroup>
              <RibbonBlockGroup>
                <div class="filter-row">
                  <span>原文：</span>
                  <el-input
                    size="mini"
                    style="width: 150px"
                    v-model="filter.src"
                    placeholder="请输入原文"
                  ></el-input>
                </div>
                <div class="filter-row">
                  <span>译文：</span>
                  <el-input
                    size="mini"
                    style="width: 150px"
                    v-model="filter.tgt"
                    placeholder="请输入译文"
                  ></el-input>
                </div>
              </RibbonBlockGroup>
              <RibbonBlockGroup>
                <div class="filter-row">
                  <span>词频&nbsp;&nbsp;>=&nbsp;&nbsp;</span>
                  <ve-input-number
                    class="input-number__word-count"
                    size="mini"
                    :min="1"
                    v-model="filter.frequency"
                  ></ve-input-number>
                  <span>&nbsp;次</span>
                </div>
              </RibbonBlockGroup>
              <el-button @click="resetATEFilter" style="margin: 0 8px"
                >重置</el-button
              >
            </template>
          </RibbonBlock>
        </RibbonPanel>
      </RibbonTable>
      <div class="alignment__body flex-col" v-if="pageLocation == 'aligment'">
        <el-table
          :data="rows"
          size="small"
          class="flex-col"
          border
          :cell-class-name="setCellClassName"
          :show-header="false"
          @cell-click="handleCellClick"
          @cell-dblclick="handleCellDblClick"
          ref="table"
        >
          <el-table-column
            align="center"
            type="index"
            label=" "
            width="48"
            column-key="row-index"
          ></el-table-column>
          <el-table-column
            :key="column.key"
            v-for="column in columns"
            :column-key="column.key"
            :class-name="`sentence-cell__${column.key} cell--editable`"
          >
            <template v-slot="scope">
              <div
                :class="
                  !currentCellValidator.check(scope.row[column.key]).valid &&
                  'cell--invalid'
                "
                :title="
                  currentCellValidator.check(scope.row[column.key]).message
                "
              >
                <div v-if="isInputReadonly(scope)" class="cell--readonly">
                  {{ scope.row[column.key] }}
                </div>
                <el-input
                  v-else
                  autosize
                  v-model="scope.row[column.key]"
                  @input.native="handleInput"
                  @blur="handleBlur"
                  type="textarea"
                >
                </el-input>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wrapper">
          <span class="lang-direction">语言： {{ langDirection }}</span>
          <el-pagination
            background
            class="pagination"
            layout="total,sizes,prev,pager,next"
            :total="paginationOptions.total"
            :page-size="paginationOptions.pageSize"
            :current-page.sync="paginationOptions.pageIndex"
            :page-sizes="[50, 100, 200]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            ref="pagination"
          ></el-pagination>
        </div>
      </div>
      <dir class="term__body flex-col" style="margin: 0; padding: 0" v-else>
        <ExtractTermList
          ref="termList"
          :project="ateProject"
          :lines="lines"
          :terms="terms"
          :filter="filter"
        ></ExtractTermList>
      </dir>
    </el-card>
    <ATESelectionDialog ref="ate-selection-dialog"></ATESelectionDialog>
  </div>
</template>

<script>
import {
  RibbonTable,
  RibbonPanel,
  RibbonBlock,
  RibbonBlockGroup,
  RibbonButton,
  RibbonCheck,
  RibbonDropMenu,
  RibbonDropMenuItem,
} from "@/components/ribbon";
import {
  SELECT_MODE,
  ALIGNMENT_TASK_STATE,
  ALIGNMENT_TASK_OPTION,
  MULTIPLE_SELECTION_MODIFIER,
  OPERATION_TIPS,
  MODAL_ACTION,
  MODAL_TYPE,
  AlignmentPollApiHandler,
  InsertCommand,
  DeleteCommand,
  MoveUpCommand,
  MoveDownCommand,
  SwapCommand,
  MergeCommand,
  SplitCommand,
  EditCommand,
  OPERATION,
  KeyboardShortcutHandler,
  Paginator,
  AlignmentEditor,
  exportOptions,
  AlignmentCellChecker,
  AlignmentExportValidator,
  AlignmentCellCheckerBuilder,
} from "./components/data";
import { closeAndGotoParent } from "@/views/layout/components/data";
import {
  FONT_SIZE_MAP,
  setEditFontSize,
} from "@/views/editor/components/data";
import AlignmentApi, { startATE, retryATE } from "@/api/alignment";
import { groupBy } from "lodash";
import {
  SUPPORT_LANGUAGE_CODES,
  checkLanguageSupport, AIGC_ATE_LANGS,
} from "@/views/glossaryExtract/data";
import { waitDone } from "@/utils/dateUtils";
import { uuid } from "@/utils/uuid";
import { isBlank } from "@/utils/String";
import { downloadFile, ExportValidator } from "@/views/components/data";
import ATESelectionDialog from "@/views/components/ATESelectionDialog.vue";
import FilterBar from "../glossaryExtract/components/filterBar.vue";
import ExtractTermList from "../glossaryExtract/components/extractTermList.vue";
import { queryATEInfo, queryATETerms, saveATE } from "@/api/ATE.js";
import { checkTermTgtIsValid } from "../glossaryExtract/data";
import { merge } from "lodash";
import {AI_MODULE_CODES, TB_LANG_CODES} from "@/views/common/enums";

const CELL_VALIDATER = {
  maxLength: new AlignmentCellCheckerBuilder().withMaxLengthEnabled().build(),
  all: new AlignmentCellCheckerBuilder().withAllEnabled().build(),
};

export default {
  components: {
    RibbonTable,
    RibbonPanel,
    RibbonBlock,
    RibbonBlockGroup,
    RibbonButton,
    RibbonCheck,
    RibbonDropMenu,
    RibbonDropMenuItem,
    ATESelectionDialog,
    FilterBar,
    ExtractTermList,
  },
  data() {
    return {
      componentRootId: `catEditor_${uuid()}`,
      ALIGNMENT_TASK_STATE,
      id: "",
      state: null,
      pageLocation: "aligment",
      defaultLocation: "aligment",
      currentSelectedData: {
        inputtingCellPos: {
          row: null,
          column: null,
        },
        cursorPos: null,
        selectMode: null,
        possibleRowToEdit: null, // { src:"", tgt: "", xxxNumber: ""}
        cellPosList: [], // [{ rowNumber: null, columnKey: "" }]
      },
      prevEditableCell: null,
      editableCell: null,
      backgroundTaskMask: null,
      isAligned: false,
      columns: [
        { label: "", key: "src" },
        { label: "", key: "tgt" },
      ],
      allRows: [],
      rows: [],
      paginationOptions: {
        total: 0,
        pageIndex: 1,
        pageSize: 200,
      },
      OPERATION: Object.freeze(OPERATION),
      OPERATION_TIPS: Object.freeze(OPERATION_TIPS),
      alignmentEditor: null,
      keyboardShortcutHandler: null,
      //for extract
      //Stands for extract page changing require
      termLoaded: false,
      changeToExtractPageSymbol: false,
      filter: {
        frequency: 1,
        src: null,
        srcMinLength: 1,
        srcMaxLength: 100,
        tgt: null,
        tgtMinLength: 0,
        tgtMaxLength: 100,
        namedEntryType: null,
        onlySelectedShown: false,
      },
      ateProject: { id: null },
      lines: [],
      terms: [],
      changedTerms: [],
      currentCellValidator: CELL_VALIDATER.maxLength,
      ateSupportedLanguages: Object.freeze([
        {
          title: "智能术语提取引擎（支持语种）",
          list: SUPPORT_LANGUAGE_CODES,
        },
        {
          title: "大语言模型术语提取（支持语种）",
          list: Object.keys(AIGC_ATE_LANGS),
        },
      ]),
    };
  },
  methods: {
    resetSelectionData() {
      this.currentSelectedData.inputtingCellPos.row = null;
      this.currentSelectedData.inputtingCellPos.column = null;
      this.currentSelectedData.cursorPos = null;
      this.currentSelectedData.selectMode = null;
      this.currentSelectedData.possibleRowToEdit = null;
      this.currentSelectedData.cellPosList = [];
    },
    setCellClassName({ column, row, rowIndex }) {
      const realRowIndex = this.paginator.indexOf(row);
      const readOnlyClass = this.isInputReadonly({ column, $index: rowIndex })
        ? "cell--readonly"
        : "";
      const isCellSelected = this.currentSelectedData.cellPosList.some(
        (pos) =>
          pos.rowNumber === realRowIndex + 1 &&
          pos.columnKey === column.columnKey
      );
      if (isCellSelected) {
        return `cell--selected ${readOnlyClass}`;
      }
      const isIndexSelected = "row-index" === column.columnKey;
      if (!isIndexSelected) return readOnlyClass;
      const selectedRowCellCount = this.currentSelectedData.cellPosList.filter(
        (pos) => pos.rowNumber === realRowIndex + 1
      ).length;
      if (selectedRowCellCount === 2) {
        return "cell--selected";
      }
    },
    handleBlur() {
      const editOption = this._buildEditOption();
      this.currentSelectedData.inputtingCellPos = {
        row: null,
        column: null,
      };
      const possibleRowToEdit = this.currentSelectedData.possibleRowToEdit;
      if (possibleRowToEdit === null) return;
      this._executeEditCommand(editOption);
      this.currentSelectedData.possibleRowToEdit = null;
    },
    _buildEditOption() {
      const { row: editRowNum, column: columnToDeal } =
        this.currentSelectedData.inputtingCellPos;
      const possibleRowToEdit = this.currentSelectedData.possibleRowToEdit;
      if (
        [editRowNum, columnToDeal].some((prop) => prop === null) ||
        possibleRowToEdit === null
      )
        return null;
      const editBefore = possibleRowToEdit[columnToDeal];
      const editAfter = this.allRows[editRowNum - 1][columnToDeal];
      return {
        editBefore,
        editAfter,
        rowNumsToDeal: [editRowNum],
        columnToDeal,
      };
    },
    _executeEditCommand({
      editBefore,
      editAfter,
      rowNumsToDeal,
      columnToDeal,
    }) {
      if (editAfter === editBefore) {
        return;
      }
      const option = {
        rows: this.allRows,
        columnToDeal,
        rowNumsToDeal,
        editBefore,
        editAfter,
        operation: OPERATION.edit,
        pageIndex: this.paginationOptions.pageIndex,
      };
      const editCommand = new EditCommand(option);
      this.alignmentEditor.execute(editCommand);
    },
    handleCellClick(row, column, cellEl, event) {
      if (!column.columnKey) return;
      const possibleRowToEdit = this.currentSelectedData.possibleRowToEdit;
      if (
        this.columnKeys.some((key) => key === column.columnKey) &&
        possibleRowToEdit
      ) {
        setTimeout(() => {
          this.currentSelectedData.cursorPos = event.target.selectionStart;
        }, 0);
      }
      if (!possibleRowToEdit) this.currentSelectedData.cursorPos = null;
      const rowIndex = this.paginator.indexOf(row);
      const rowNumber = rowIndex + 1;
      let cellPosList = this.currentSelectedData.cellPosList;
      const firstSelectedNum = Math.min(
        ...cellPosList.map((pos) => pos.rowNumber)
      );
      const lastSelectedNum = Math.max(
        ...cellPosList.map((pos) => pos.rowNumber)
      );
      const minSelectedNum =
        cellPosList.length === 0 ? rowNumber - 1 : firstSelectedNum;
      const maxSelectedNum =
        cellPosList.length === 0 ? rowNumber - 1 : lastSelectedNum;
      let initialNumToHighlight;
      let lastNumToHighlight;
      if (rowNumber < maxSelectedNum) {
        const isClickedWithinSelected = rowNumber >= minSelectedNum;
        initialNumToHighlight = isClickedWithinSelected
          ? minSelectedNum
          : rowNumber;
        lastNumToHighlight = isClickedWithinSelected
          ? rowNumber
          : maxSelectedNum;
      } else {
        initialNumToHighlight = minSelectedNum;
        lastNumToHighlight = rowNumber;
      }
      if ("row-index" === column.columnKey) {
        if (MULTIPLE_SELECTION_MODIFIER.some((modifier) => event[modifier])) {
          if (this.currentSelectedData.selectMode !== SELECT_MODE.row) {
            cellPosList.splice(0, cellPosList.length);
          }
          this.currentSelectedData.cellPosList = [];
          const cellPosList = this.currentSelectedData.cellPosList;
          for (
            let num = initialNumToHighlight;
            num <= lastNumToHighlight;
            num++
          ) {
            const rowCellPosList = this.columnKeys.map((columnKey) => {
              return { rowNumber: num, columnKey };
            });
            cellPosList.push(...rowCellPosList);
          }
        } else {
          this.currentSelectedData.cellPosList = this.columnKeys.map(
            (columnKey) => {
              return { rowNumber, columnKey };
            }
          );
        }
        this.currentSelectedData.selectMode = SELECT_MODE.row;
        return;
      }
      const columnKey = column.columnKey;
      this.currentSelectedData.selectMode = SELECT_MODE[columnKey];
      if (cellPosList.some((pos) => pos.columnKey !== columnKey)) {
        this.currentSelectedData.cellPosList = [
          {
            rowNumber,
            columnKey,
          },
        ];
        return;
      }
      if (MULTIPLE_SELECTION_MODIFIER.some((modifier) => event[modifier])) {
        this.currentSelectedData.cellPosList = [];
        cellPosList = this.currentSelectedData.cellPosList;
        for (
          let num = initialNumToHighlight;
          num <= lastNumToHighlight;
          num++
        ) {
          cellPosList.push({
            rowNumber: num,
            columnKey,
          });
        }
      } else {
        this.currentSelectedData.cellPosList = [
          {
            rowNumber,
            columnKey,
          },
        ];
      }
    },
    isInputReadonly({ column, $index }) {
      return (
        column.columnKey !== this.currentSelectedData.inputtingCellPos.column ||
        this.paginator.getRealRowNum($index + 1) !==
          this.currentSelectedData.inputtingCellPos.row
      );
    },
    handleCellDblClick(row, column, cellEl, event) {
      const index = this.paginator.indexOf(row);
      const currentInputCellPos = { row: index + 1, column: column.columnKey };
      if (
        column.columnKey === this.currentSelectedData.inputtingCellPos.column &&
        index === this.currentSelectedData.inputtingCellPos.row - 1
      ) {
        return;
      }
      this.currentSelectedData.inputtingCellPos = currentInputCellPos;
      setTimeout(() => {
        this._handleReadonlyToInput(cellEl.querySelector("textarea"));
      }, 0);
      this.currentSelectedData.possibleRowToEdit = { ...row };
    },
    _handleReadonlyToInput(inputEl) {
      this.currentSelectedData.cursorPos = inputEl.selectionStart;
      const end = inputEl.value.length;
      inputEl.setSelectionRange(end - 1, end - 1);
      inputEl.focus();
    },
    handleInput(event) {
      this.currentSelectedData.cursorPos = event.target.selectionStart;
    },
    handleClickUndo() {
      this.alignmentEditor.undo();
    },
    _handleAfterExecution({ rowNumsToDeal, columnToDeal }) {
      const rows = this.allRows.filter((row, i) =>
        rowNumsToDeal.includes(i + 1)
      );
    },
    _handleAfterRepeatedAction({ rowNumsToDeal, columnToDeal }) {
      this._recoverHighlightedCells(rowNumsToDeal, columnToDeal);
      this._reloadPageRowsAfterRepeat(rowNumsToDeal);
    },
    _recoverHighlightedCells(rowNumsToDeal, columnToDeal) {
      this.currentSelectedData.inputtingCellPos = {
        row: null,
        column: null,
      };
      this.currentSelectedData.possibleRowToEdit = null;
      this.currentSelectedData.cellPosList = [];
      this.currentSelectedData.selectMode = columnToDeal;
      if (columnToDeal === SELECT_MODE.row) {
        rowNumsToDeal.forEach((rowNumber) => {
          this.currentSelectedData.cellPosList.push(
            ...this.columnKeys.map((columnKey) => {
              return { columnKey, rowNumber };
            })
          );
        });
      } else {
        rowNumsToDeal.forEach((rowNumber) => {
          this.currentSelectedData.cellPosList.push({
            columnKey: columnToDeal,
            rowNumber,
          });
        });
      }
    },
    handleClickRedo() {
      this.alignmentEditor.redo();
    },
    _reloadPageRowsAfterRepeat(rowNumsToDeal) {
      const pageNumOfDealtRows = this.paginator.getBelongedPage(
        Math.min(...rowNumsToDeal),
        this.paginationOptions.pageSize
      );
      if (this.paginator.isRowRangeInCurrentPage(rowNumsToDeal)) return;
      if (this.paginationOptions.pageIndex !== pageNumOfDealtRows)
        this.handleCurrentChange(pageNumOfDealtRows);
    },
    async handleClickOperation(op) {
      const cellPosList = this.currentSelectedData.cellPosList;
      if (cellPosList.length === 0) {
        this.$$flash(op.disabledMsg, "warning");
        return;
      }
      const rowNumsToDeal = Object.keys(
        groupBy(this.currentSelectedData.cellPosList, "rowNumber")
      ).map(Number);
      const option = {
        rows: this.allRows,
        columnToDeal: this.currentSelectedData.selectMode,
        rowNumsToDeal,
        firstRowNumToDeal: Math.min(...rowNumsToDeal),
        operation: op,
        pageIndex: this.paginationOptions.pageIndex,
      };
      switch (op) {
        case this.OPERATION.insert:
          this.insert(option);
          break;
        case this.OPERATION.delete:
          this.delete(option);
          break;
        case this.OPERATION.moveup:
          this.moveup(option);
          break;
        case this.OPERATION.movedown:
          this.movedown(option);
          break;
        case this.OPERATION.swap:
          this.swap(option);
          break;
        case this.OPERATION.merge:
          if (option.rowNumsToDeal.length === 1) {
            this.$$flash(op.disabledMsg, "warning");
            return;
          }
          this.merge(option);
          break;
        case this.OPERATION.split:
          if (
            cellPosList.length > 1 ||
            this.currentSelectedData.cursorPos === null
          ) {
            this.$$flash(op.disabledMsg, "warning");
            return;
          }
          this.split({
            ...option,
            cursorPos: this.currentSelectedData.cursorPos,
          });
          this.currentSelectedData.cursorPos = null;
      }
    },
    handleShortcutSent(op) {
      const possibleRowToEdit = this.currentSelectedData.possibleRowToEdit;
      if (possibleRowToEdit) {
        if (op === OPERATION.undo) {
          this._executeEditCommand(this._buildEditOption());
        } else if (op !== OPERATION.split) return;
      }
      switch (op) {
        case OPERATION.multipleUp:
        case OPERATION.multipleDown:
          const selectedRowNums = Object.keys(
            groupBy(this.currentSelectedData.cellPosList, "rowNumber")
          ).map(Number);
          if (selectedRowNums.length === 0) return;
          const selectMode = this.currentSelectedData.selectMode;
          if (op === OPERATION.multipleUp) {
            const firstSelectedRowNum = Math.min(...selectedRowNums);
            if (firstSelectedRowNum === 1) return;
            const selectedCellToAdd =
              selectMode === SELECT_MODE.row
                ? this.columnKeys.map((key) => {
                    return {
                      columnKey: key,
                      rowNumber: firstSelectedRowNum - 1,
                    };
                  })
                : [
                    {
                      columnKey: selectMode,
                      rowNumber: firstSelectedRowNum - 1,
                    },
                  ];
            this.currentSelectedData.cellPosList.unshift(...selectedCellToAdd);
          }
          if (op === OPERATION.multipleDown) {
            const lastSelectedRowNum = Math.max(...selectedRowNums);
            if (this.paginator.isRealLastRow(lastSelectedRowNum)) return;
            const selectedCellToAdd =
              selectMode === SELECT_MODE.row
                ? this.columnKeys.map((key) => {
                    return {
                      columnKey: key,
                      rowNumber: lastSelectedRowNum + 1,
                    };
                  })
                : [
                    {
                      columnKey: selectMode,
                      rowNumber: lastSelectedRowNum + 1,
                    },
                  ];
            this.currentSelectedData.cellPosList.push(...selectedCellToAdd);
          }
          return;
        case OPERATION.undo:
          this.handleClickUndo();
          return;
        case OPERATION.redo:
          this.handleClickRedo();
          return;
        default:
          this.handleClickOperation(op);
      }
    },
    insert(option) {
      const isPassed = this._checkInsDel(option);
      if (!isPassed) {
        this.$$flash("无段落内容，无法插入新的句子", "warning");
        return;
      }
      const insertCommand = new InsertCommand(option);
      this.alignmentEditor.execute(insertCommand);
      this._handleAfterInsert(option.rowNumsToDeal);
    },
    _handleAfterInsert(rowNumsToDeal) {
      const highlightedRowNum = Math.min(...rowNumsToDeal);
      this.currentSelectedData.cellPosList =
        this.currentSelectedData.cellPosList.filter(
          (pos) => pos.rowNumber === highlightedRowNum
        );
      this.currentSelectedData.cellPosList.forEach((pos) => pos.rowNumber++);
    },
    delete(option) {
      const isPassed = this._checkInsDel(option);
      if (!isPassed) {
        this.$$flash("无法删除：下文均为空白句子", "warning");
        return;
      }
      const deleteCommand = new DeleteCommand(option);
      this.alignmentEditor.execute(deleteCommand);
      this._handleAfterDelete(option.rowNumsToDeal);
    },
    _checkInsDel({ columnToDeal, rowNumsToDeal }) {
      if (columnToDeal === SELECT_MODE.row) return true;
      const rowsBelow = this.allRows.slice(Math.min(...rowNumsToDeal) - 1);
      const hasTextBelow = rowsBelow.some((row) => row[columnToDeal]);
      return hasTextBelow;
    },
    async _handleAfterDelete(rowNumsToDeal) {
      if (this.allRows.length === 0) {
        this.currentSelectedData.cellPosList = [];
        return;
      }
      await this.$nextTick();
      if (this.rows.length === 0) {
        this.loadPageRows();
        return;
      }
      this.highlightFirstSelectedRow(rowNumsToDeal);
    },
    moveup(option) {
      if (option.firstRowNumToDeal === 1) {
        this.$$flash(
          `当前${this._getCurrentSelectedMode(option.columnToDeal)}已是第一行`,
          "warning"
        );
        return;
      }
      const moveupCommand = new MoveUpCommand(option);
      this.alignmentEditor.execute(moveupCommand);
      this._handleAfterMoveUp();
      if (this.paginator.isCurrentPageFirstRow(option.firstRowNumToDeal)) {
        // 上移时，跳至上一页的处理：加载上一页/滚动条至末端
        this._handleMoveUpToPrevPage();
      }
    },
    _handleAfterMoveUp() {
      this.currentSelectedData.cellPosList.forEach((pos) => pos.rowNumber--);
    },
    async _handleMoveUpToPrevPage() {
      this.paginationOptions.pageIndex -= 1;
      await this.$nextTick();
      const bodyWrapperEl = this.$refs.table.bodyWrapper;
      bodyWrapperEl.scrollTop = bodyWrapperEl.scrollHeight;
    },
    movedown(option) {
      const maxSelectedRowNum = Math.max(...option.rowNumsToDeal);
      if (this.paginator.isRealLastRow(maxSelectedRowNum)) {
        this.$$flash(
          `当前${this._getCurrentSelectedMode(
            option.columnToDeal
          )}已是最后一行`,
          "warning"
        );
        return;
      }
      const movedownCommand = new MoveDownCommand(option);
      this.alignmentEditor.execute(movedownCommand);
      this._handleAfterMoveDown();
      if (this.paginator.isCurrentPageLastRow(maxSelectedRowNum)) {
        // 下移时，跳至下一页的处理：加载下一页/滚动条至顶端
        this._handleMoveDownToNextPage();
      }
    },
    async _handleMoveDownToNextPage() {
      this.paginationOptions.pageIndex += 1;
      await this.$nextTick();
      this.$refs.table.bodyWrapper.scrollTop = 0;
    },
    _handleAfterMoveDown() {
      this.currentSelectedData.cellPosList.forEach((pos) => pos.rowNumber++);
    },
    swap(option) {
      const swapComand = new SwapCommand(option);
      this.alignmentEditor.execute(swapComand);
    },
    merge(option) {
      const mergeCommand = new MergeCommand(option);
      this.alignmentEditor.execute(mergeCommand);
      this._handleAfterMerge(option.rowNumsToDeal);
    },
    _handleAfterMerge(rowNumsToDeal) {
      this.highlightFirstSelectedRow(rowNumsToDeal);
    },
    split(option) {
      const splitCommand = new SplitCommand(option);
      this.alignmentEditor.execute(splitCommand);
      this._handleAfterSplit();
    },
    _handleAfterSplit() {
      const selected = this.currentSelectedData.cellPosList[0];
      this.currentSelectedData.cellPosList = [
        selected,
        { ...selected, rowNumber: selected.rowNumber++ },
      ];
    },
    setFontSize(command) {
      this._unsetFontSize = setEditFontSize(
        this.componentRootId,
        FONT_SIZE_MAP[command]
      );
    },
    _getCurrentSelectedMode(columnToDeal) {
      return SELECT_MODE.row === columnToDeal ? "行" : "单元格";
    },
    highlightFirstSelectedRow(selectedRowNums) {
      this.currentSelectedData.cellPosList =
        this.currentSelectedData.cellPosList.filter(
          (pos) => pos.rowNumber === Math.min(...selectedRowNums)
        );
    },
    async handleExportCommand(command, exportOption) {
      const exportValidator = exportOption.validator();
      try {
        exportValidator.validate({
          rowCount: (this[exportOption.rowsProp] || []).length,
        });
      } catch (error) {
        this.$$flash(error.message, "warning");
        return;
      }
      const loading = this.$$loading();
      const type = Object.values(this.exportOptions).indexOf(exportOption);
      const format = exportOption.formats[command];
      try {
        const success = await exportOption.saveBeforeExport();
        if (!success) return;
        await downloadFile(() =>
          AlignmentApi.export({
            id: this.id,
            format,
            type,
            filter: JSON.stringify(
              !!exportOption.filter ? exportOption.filter() : null
            ),
          })
        );
      } catch (error) {
        this.$$error(error);
      } finally {
        loading.close();
      }
    },
    async handleClickSave() {
      this.saveRows();
    },
    async _saveCore() {
      const rows = this.allRows;
      rows.forEach((row, i) => {
        if (row.sentenceNumber === i + 1) return;
        row.sentenceNumber = i + 1;
      });
      const { action } = await this._executeModalEnabledApi(() =>
        AlignmentApi.saveRows({ id: this.id, sentences: rows })
      );
      if (action === MODAL_ACTION.notShown) return true;
      if (action === MODAL_ACTION.confirm) {
        return this._saveCore();
      }
      if (action === MODAL_ACTION.closeTab) {
        closeAndGotoParent();
      }
      return false;
    },
    async saveRows() {
      this.currentCellValidator = CELL_VALIDATER.maxLength;
      try {
        const success = await this._saveCore();
        if (!success) return;
      } catch (error) {
        this.$$error(error);
        return;
      }
      this.$$flash("句子保存成功", "success");
    },
    async handleExtract() {
      // await user to select ate engine
      let ateEngine;
      try {
        ateEngine = await this.$refs["ate-selection-dialog"].show(AI_MODULE_CODES.bilingualTermExtraction);
      } catch (error) {
        this.$$error(error);
        return;
      }
      if (!ateEngine.ateEngineId) return;
      // todo check language support according to engine selection
      if (
        !ateEngine.aigc &&
        !checkLanguageSupport(this.columns[0].label, this.columns[1].label)
      ) {
        this.$$flash("无法提取术语，语种暂不支持。", "warning");
        return;
      }

      if (
        !this.paginationOptions ||
        this.paginationOptions.total < 1 ||
        (this.allRows || []).$$all((r) => isBlank(r.src) && isBlank(r.tgt))
      ) {
        this.$$flash("没有句子内容，无法进行术语提取。", "warning");
        return;
      }

      const laoding = this._createLoading("正在自动提取术语，请稍候...");
      let newATEId = null;
      try {
        //Save before extracting
        const success = await this._saveCore();
        if (!success) return;
        const extracId = await startATE(
          this.id,
          (this.ateProject || {}).id,
          ateEngine
        );
        newATEId = extracId;
      } catch (err) {
        this.$$error(`术语提取失败：${err}`);
        return;
      } finally {
        laoding && laoding.close();
      }

      this.state = ALIGNMENT_TASK_STATE.extractingTerm;
      if (!!newATEId) {
        const waitATEDoneLoading =
          this._createLoading("正在自动提取术语，请稍候...");
        const cleaning = () => waitATEDoneLoading && waitATEDoneLoading.close();
        waitDone(async () => {
          let isDone = false;
          console.log("#-# this._isDestroyed", this._isDestroyed);
          if (!this._isDestroyed) {
            try {
              const { data: ateState, action } =
                await this._executeModalEnabledApi(() => this.getTaskState());
              if (action === MODAL_ACTION.confirm) {
                isDone = false;
                return isDone;
              }
              if (action === MODAL_ACTION.cancel) {
                cleaning();
                isDone = true;
                return isDone;
              }
              if (action === MODAL_ACTION.closeTab) {
                closeAndGotoParent();
                cleaning();
                return true;
              }
              this.state = ateState.state;
              console.log("#-# ateState", ateState, this._isDestroyed);
              if (this._isDestroyed) {
                isDone = true;
              } else {
                if (ateState.state == ALIGNMENT_TASK_STATE.extractDone) {
                  console.log("#-# ate state", ateState);
                  isDone = true;
                  this.termLoaded = false;
                  this.ateProject.id = ateState.ateId;
                  this._navigateToTermPage();
                } else if (
                  ateState.state == ALIGNMENT_TASK_STATE.extractError
                ) {
                  isDone = true;
                  this.ateProject.id = ateState.ateId;
                  this.$$error(
                    `自动提取术语失败，详细信息:${ateState.stateMessage}`
                  );
                }
              }
            } catch (err) {
              //ignore
            }
          } else {
            isDone = true;
          }

          if (isDone) {
            cleaning();
          }
          return isDone;
        }, 1000 * 5);
      }
    },
    viewExtract() {
      this._navigateToTermPage();
    },
    waitFor(option) {
      this.setBackgroundTaskMask(option.waiting.msg);
      waitDone(() => {
        try {
          return this.pollTaskState(option);
        } finally {
          if (this._isDestroyed) return true;
        }
      }, 5 * 1000);
    },
    async _executeModalEnabledApi(api) {
      let data = null;
      const result = await AlignmentPollApiHandler.execute(api);
      if (result.success)
        return {
          data: result.data,
          action: MODAL_ACTION.notShown,
        };
      this.closeBackgroundTaskMask();
      if (result.modalOption.type === MODAL_TYPE.confirm) {
        return {
          data,
          action: await this._getConfirmModalResult(result.modalOption),
        };
      }
      if (result.modalOption.type === MODAL_TYPE.retry) {
        return {
          data,
          action: await this._getRetryModalResult(result.modalOption),
        };
      }
    },
    async _getRetryModalResult({ message }) {
      if (this._isDestroyed) return MODAL_ACTION.cancel;
      try {
        await this._popupModal(message);
      } catch {
        // `x` clicked
        return MODAL_ACTION.cancel;
      }
      // retry clicked
      return MODAL_ACTION.confirm;
    },
    async _getConfirmModalResult({ message, buttonText }) {
      try {
        await this._popupModal(message, buttonText);
      } catch {
        return MODAL_ACTION.cancel;
      }
      return MODAL_ACTION.closeTab;
    },
    async pollTaskState(option) {
      const { data, action } = await this._executeModalEnabledApi(() =>
        this.getTaskState()
      );
      if (action === MODAL_ACTION.confirm) {
        this.setBackgroundTaskMask(option.waiting.msg);
        return false;
      }
      if (action === MODAL_ACTION.cancel) return true;
      if (action === MODAL_ACTION.closeTab) {
        closeAndGotoParent();
        return true;
      }
      console.log("#-# ate state", data);
      const { state, stateMessage, ateId } = data;
      this.state = state;
      this.ateProject.id = ateId;
      if (option.expect.state.includes(state)) {
        this.closeBackgroundTaskMask();
        if (this._isDestroyed) return true;
        this.$$flash(option.expect.msg, "success");
        if (option.next) {
          this.waitFor(option.next);
          return true;
        }
        // 加载
        await this._handleLoadRows(state);
        if (option.postCheckOption) {
          this._checkRows(option.postCheckOption);
        }
        return true;
      }
      if (option.unexpect.state.includes(state)) {
        this.closeBackgroundTaskMask();
        if (this._isDestroyed) return true;
        let message;
        try {
          ({ message } = JSON.parse(stateMessage));
        } catch (error) {
          if (!!stateMessage) message = stateMessage;
        }
        // check is empty before popup
        const api = () => AlignmentApi.getSentences({ taskId: this.id });
        const { data, stop } = await this._executeRetryableApi(api);
        if (stop) return true;
        if (!data || data.length === 0) {
          try {
            await this._popupModal(`${option.unexpect.msg}${message}`, "确定");
          } finally {
            return true;
          }
        } else {
          await this._popupModal(`${option.unexpect.msg}${message}`);
        }

        try {
          if (option === ALIGNMENT_TASK_OPTION.extract) {
            await retryATE(this.ateProject.id);
          } else {
            await AlignmentApi.retry({ id: this.id });
          }
        } catch (error) {
          this.$$error(`术语提取失败：${error}`);
          return true;
        }
        this.waitFor(option);
        return true;
      }
      return false;
    },
    _checkRows(postCheckOption) {
      const invalid = this.allRows.some((row) => {
        return this.columns.some((column) => {
          return !postCheckOption.checker.check(row[column.key]).valid;
        });
      });
      if (invalid) {
        this.$$flash(postCheckOption.message, "warning");
      }
    },
    async _popupModal(message, buttonText = "重试") {
      return this.$confirm(message, "系统提示", {
        showCancelButton: false,
        closeOnClickModal: false,
        confirmButtonText: buttonText,
        type: "error",
        lockScroll: false,
      });
    },
    _navigateToTermPage() {
      this.pageLocation = "extract";
      this.loadTermData();
    },
    async _handleLoadRows(state) {
      if (
        ALIGNMENT_TASK_STATE.aligned === state ||
        state >= ALIGNMENT_TASK_STATE.extractingTerm
      ) {
        this.isAligned = true;
        await this.loadSentences();
        if (
          this.changeToExtractPageSymbol === "extract" &&
          state === ALIGNMENT_TASK_STATE.extractDone
        ) {
          this.pageLocation = "extract";
        }
      }
    },
    async getTaskState() {
      return AlignmentApi.getTaskState({ id: this.id });
    },
    _createLoading(message) {
      if (this._isDestroyed) return null;
      return this.$$loading(null, {
        component: "progress",
        data: {
          progressing: false,
          message,
        },
      });
    },
    setBackgroundTaskMask(message) {
      this.backgroundTaskMask = this._createLoading(message);
    },
    closeBackgroundTaskMask() {
      if (!this.backgroundTaskMask) return;
      this.backgroundTaskMask.close();
      this.backgroundTaskMask = null;
    },
    async loadSentences() {
      let response;
      const loading = this.$$loading();
      try {
        response = await AlignmentApi.getSentences({
          taskId: this.id,
        });
        if (!response.data.success) throw response.data.error;
      } catch (error) {
        this.$$error(error);
        throw error;
      } finally {
        loading && loading.close();
      }
      this.initializePageRows(response.data.data || []);
    },
    initializePageRows(rows) {
      this.allRows = rows;
      this.paginationOptions.total = rows.length;
      this.paginator = new Paginator(this.allRows);
    },
    loadPageRows() {
      const { pageIndex, pageSize } = this.paginationOptions;
      this.rows = this.paginator
        ? this.paginator.load(pageIndex, pageSize)
        : [];
    },
    // 分页设置
    handleSizeChange(size) {
      this.paginationOptions.pageSize = size;
      this.loadPageRows();
    },
    handleCurrentChange(currentPage) {
      this.paginationOptions.pageIndex = currentPage;
      this.loadPageRows();
      this.$refs.table.bodyWrapper.scrollTop = 0;
    },

    async loadTermData() {
      const loading = this.$$loading("正在加载句对数据，请稍候...");
      try {
        console.log("#-# queryATEInfo", this.ateProject);
        const projectInfo = await queryATEInfo({id:this.ateProject.id});
        const terms = await queryATETerms({id:this.ateProject.id});
        this.ateProject = projectInfo;
        this.lines = projectInfo.lines;
        this.terms = terms;
        this.termLoaded = true;
      } catch (err) {
        this.terms = [];
        this.$$error(err);
      } finally {
        loading && loading.close();
      }
    },
    resetATEFilter() {
      for (const attr in this._ateFilterCopy) {
        this.filter[attr] = this._ateFilterCopy[attr];
      }
    },
    async deleteATE() {
      const selectedTerms = this.$refs.termList.getSelectedTerms();
      if (selectedTerms.length < 1) {
        this.$$flash("请勾选需要删除的术语。", "warning");
        return;
      }
      !!this.$refs.termList && this.$refs.termList.deleteSelectedTerms();
    },
    _resetTermEditChange() {
      if (!!this.$refs.termList) {
        this.$refs.termList.resetChangedRows();
        this.$refs.termList.resetLineValidateResult();
      }
    },
    async saveATE() {
      if ((this.terms || []).length == 0) {
        this.$$flash("无法保存，术语不能为空。", "warning");
        return;
      }

      const validateResult = this.$refs.termList.validate();
      if (!validateResult) {
        this.$$flash(
          "术语无法保存，部分数据不符合规范，详见条目内错误提示。",
          "warning"
        );
        return;
      }

      const loading = this.$$loading("正在保存数据修改，请稍候...");
      let saveSuccess = false;
      try {
        saveSuccess = await this.doSaveATE();
        this.$$flash("保存成功", "success");
      } catch (error) {
        this.$$error(error);
      } finally {
        loading && loading.close();
      }
    },
    async doSaveATE() {
      const changedTerms = this.$refs.termList.getChangedTerms();
      const deletedTerms = changedTerms.deleted.map((t) => t.id);
      const editedTerms = changedTerms.edited.map((t) => ({
        id: t.id,
        src: t.src,
        tgt: t.tgt,
      }));

      if (deletedTerms.length <= 0 && editedTerms.length <= 0) {
        return true;
      }

      const saveForm = {
        id: this.ateProject.id,
        deletedTerms,
        editedTerms,
      };
      await saveATE(saveForm);
      this._resetTermEditChange();
      return true;
    },
    async _executeRetryableApi(api) {
      const { data, action } = await this._executeModalEnabledApi(api);
      if (action === MODAL_ACTION.confirm) {
        return this._executeRetryableApi(api);
      }
      if (action === MODAL_ACTION.cancel)
        return {
          data,
          stop: true,
        };
      if (action === MODAL_ACTION.closeTab) {
        closeAndGotoParent();
        return {
          data,
          stop: true,
        };
      }
      return {
        data,
        stop: false,
      };
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.alignmentEditor = new AlignmentEditor();
    this.alignmentEditor.afterExecution((option) => {
      this._handleAfterExecution(option);
    });
    this.alignmentEditor.afterRepetition((option) =>
      this._handleAfterRepeatedAction(option)
    );
    this.keyboardShortcutHandler = new KeyboardShortcutHandler();
    this.keyboardShortcutHandler.whenOperationSent((operation) =>
      this.handleShortcutSent(operation)
    );
    this.defaultLocation = this.$route.query.defaultLocation || "alignment";
    this._ateFilterCopy = { ...this.filter };
  },
  beforeDestroy() {
    this.alignmentEditor.clearStack();
    this.keyboardShortcutHandler.cleanup();
    this.closeBackgroundTaskMask();
  },
  destroyed() {
    document.title = this._documentTitleBackup;
    !!this._unsetFontSize && this._unsetFontSize();
  },
  async mounted() {
    let { data, stop } = await this._executeRetryableApi(() =>
      AlignmentApi.getLangs({
        id: this.id,
      })
    );
    if (stop) return;
    this.columns.forEach((column) => {
      column.label = `${data[`${column.key}Lang`]}`;
    });
    ({ data, stop } = await this._executeRetryableApi(() =>
      this.getTaskState()
    ));
    if (stop) return;
    const { name, state, ateId } = data;
    this._documentTitleBackup = document.title;
    document.title = `双语对齐-${name}`;
    this.$store.dispatch("setAlignmentTaskName", name);
    this.ateProject.id = ateId;
    this.state = state;
    console.log("#-# mounted state", state);
    await this._handleLoadRows(state);

    let needWaitFor = true;
    if (this.defaultLocation == "extract") {
      if (this.state >= ALIGNMENT_TASK_STATE.extractingTerm) {
        this.pageLocation = "extract";
        if (this.state === ALIGNMENT_TASK_STATE.extractDone) {
          needWaitFor = false;
          this.loadTermData();
        }
      }
    } else {
      if (this.state == ALIGNMENT_TASK_STATE.aligned) {
        needWaitFor = false;
      }
      if (this.state >= ALIGNMENT_TASK_STATE.extractDone) {
        needWaitFor = false;
      }
    }

    if (!needWaitFor) return;
    const pollOption =
      state < ALIGNMENT_TASK_STATE.aligning
        ? ALIGNMENT_TASK_OPTION.parse
        : state < ALIGNMENT_TASK_STATE.extractingTerm
        ? ALIGNMENT_TASK_OPTION.align
        : ALIGNMENT_TASK_OPTION.extract;
    this.waitFor(pollOption);
  },
  computed: {
    columnKeys() {
      return this.columns.map((column) => column.key);
    },
    langDirection() {
      const langs = this.columns.map((column) => column.label);
      return langs.filter(Boolean).length === 0 ? "-" : langs.join(" -> ");
    },
    currentPageIndex() {
      return this.paginationOptions.pageIndex;
    },
    exportOptions() {
      const self = this;
      const extraOptions = {
        tm: {
          rowsProp: "allRows",
          saveBeforeExport: () => {
            return this._saveCore();
          },
          filter: null,
          validator: () => {
            this.currentCellValidator = CELL_VALIDATER.all;
            return new AlignmentExportValidator(this.allRows);
          },
        },
        tb: {
          rowsProp: "terms",
          saveBeforeExport: () => {
            return this.doSaveATE();
          },
          filter() {
            return {
              selectedTerms: self.$refs.termList
                .getSelectedTerms()
                .map((t) => t.id),
              orderBy: self.$refs.termList.getSortRule(),
            };
          },
          validator: () => {
            return {
              validate() {
                const selectedTerms = self.$refs.termList.getSelectedTerms();
                if (selectedTerms.length < 1) {
                  throw new Error("请勾选需要导出的术语。");
                }
              },
            };
          },
        },
      };
      return merge(exportOptions, extraOptions);
    },
  },
  watch: {
    allRows(newValue) {
      this.loadPageRows();
      this.paginationOptions.total = newValue.length;
    },
    currentPageIndex() {
      this.resetSelectionData();
    },
    htmlTitle(newValue) {
      if (!!newValue) {
        document.title = newValue;
      }
    },
    pageLocation(newValue) {
      if (newValue !== "extract") {
        this.keyboardShortcutHandler.enable();
        return;
      }
      this.keyboardShortcutHandler.disable();
      if (!this.termLoaded) {
        this.loadTermData();
      }
    },
  },
};
</script>

<style lang="scss">
.page--cat-alignment__editor {
  position: relative;
  min-height: 0;
  border: 0;
  background-color: inherit;
  padding: 0;
  display: flex;
  flex: 1;
  .alignment {
    &__editor-wrapper {
      position: relative;
      flex: 1;
      min-height: 0;
      .el-card__body {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
    }
    &__supported-glossary-langs {
      .ribbon-button__text {
        float: right;
      }
    }
    &__separator {
      margin: 5px 0px;
    }
    &__seprator--vertical {
      height: 32px;
    }
    &__toolbar {
      margin-bottom: 5px;
      display: inline-flex;
      .alignment-operation-tip-ref {
        margin-left: auto;
        align-self: center;
      }
    }
    &__body {
      flex: 1;
      min-height: 0;
      .el-button-group,
      .el-button--swap {
        margin-left: 10px;
      }
      .el-table {
        flex: 1;
        border: 1px solid #ebebeb;
        border-bottom-width: 0;
        &__body-wrapper {
          flex: 1;
          overflow-y: auto;
          .cell {
            &--editable {
              .cell {
                line-height: 1.5;
                &--valid,
                &--invalid {
                  padding: 8px 0;
                }
                &--valid {
                  border: 1px solid transparent;
                }
                &--invalid {
                  border: 1px solid #f56c6c;
                }
                &--readonly {
                  overflow-wrap: break-word;
                  text-align: justify;
                  text-align-last: left;
                  word-break: normal;
                  letter-spacing: 0;
                }
              }
              .el-textarea {
                font-size: inherit;
                &__inner {
                  font-size: inherit;
                  line-height: inherit;
                  padding: 0;
                  background-color: transparent;
                  border-width: 0px;
                  resize: none;
                  overflow: hidden;
                  text-align: justify;
                  text-align-last: left;
                  border-radius: 0;
                  word-break: normal;
                  letter-spacing: 0;
                  :focus {
                    border-color: transparent;
                  }
                  :hover {
                    border-color: transparent;
                  }
                }
              }
            }
            &--readonly {
              user-select: none;
              .el-textarea__inner {
                cursor: pointer;
              }
            }
            &--selected {
              background-color: #fff7b8 !important;
            }
            &__tgt {
              padding-right: 15px;
            }
          }
        }
        &__row {
          .sentence-cell {
            &__tgt {
              padding-right: 20px;
            }
          }
        }
        &__cell {
          vertical-align: top;
        }
      }
      .pagination-wrapper {
        border: 1px solid #ebebeb;
        border-top-width: 0px;
        .lang-direction {
          float: left;
          margin: 8px 0px 8px 5px;
          line-height: 28px;
          font-size: 13px;
        }
        .pagination {
          float: right;
          margin: 6px 0;
        }
      }
    }
  }
  .el-card {
    &__body {
      padding: 0 10px 10px;
      .component--ribbon__button {
        &.size-large {
          .ribbon-button__image .ribbon-button__image-icon {
            margin-right: 0;
          }
        }
        &.size-small {
          display: flex;
          .ribbon-button__image {
            display: inline-flex;
            flex: 1;
          }
        }
      }
    }
  }

  .term__body {
    flex: 1;
    overflow-y: auto;

    .el-table {
      flex: 1;
      border: 1px solid #ebebeb;
      border-bottom-width: 0;
      &__body-wrapper {
        flex: 1;
        overflow-y: auto;
      }
    }
  }

  .filter-row {
    span {
      font-size: 12px;
    }
    padding: 2px 0;
  }
  .input-number__word-count {
    width: 45px;
    display: inline-block;
  }
}
</style>
